/**
 * Import Dialog
 *
 * Dialog that imports workflows from a CSV file of test cases.
 */

import { Dialog, DialogTrigger, DialogContent, Button, type SelectOption } from '@chatsdet/ui';
import { CsvImportForm } from './CsvImportForm';

type ImportDialogProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  /** Property options for CSV default property */
  propertyOptions: SelectOption[];
  showPropertySelect: boolean;
  /** Called when CSV upload starts */
  onCsvSubmit: (file: File, defaultPropertyId?: string | null) => void;
  csvIsPending: boolean;
};

export function ImportDialog({
  isOpen,
  onOpenChange,
  propertyOptions,
  showPropertySelect,
  onCsvSubmit,
  csvIsPending,
}: ImportDialogProps) {
  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={onOpenChange}>
      <Button className="hidden" />
      <Dialog title="Upload CSV" description="Import workflow candidates from a CSV file.">
        <DialogContent>
          <CsvImportForm
            propertyOptions={propertyOptions}
            showPropertySelect={showPropertySelect}
            onSubmit={(file, propertyId) => {
              onCsvSubmit(file, propertyId);
            }}
            isPending={csvIsPending}
            onCancel={handleCancel}
          />
        </DialogContent>
      </Dialog>
    </DialogTrigger>
  );
}
